import { Submit } from '@radix-ui/react-form'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation, useNavigate, Link } from 'react-router-dom'

import useAuth, { Credentials } from '../hooks/auth.service'
import { Area, Button, Container } from '../styles/_app.style'
import { Control, Header2, Field, Form, Label, Message, Name, Tagline, LoginWrapper, FormArea, RegisterArea, FormActions, StepContent} from '../styles/login.style'
import { LocationState } from '../types/global'
import { titles } from '../constants/titles'
import { useScale } from './HeightScaler'
import { NAVIGATION_HEIGHT } from '../constants/global'
import { BookLogo } from '../components/common/BookLogo'
import { AuthSkyline } from '../components/common/AuthSkyline'




const Login = () => {
  const { loginUser, isLoggedIn } = useAuth()
  const navigate = useNavigate()
  const { state } = useLocation()
  const homePath = '/strippedTimeline'
  const {scale} = useScale()
  const displacement = 4 / scale


  useEffect(() => {
    const { next } = (state as LocationState) || { next: undefined }
    if (isLoggedIn) navigate(next || homePath, { replace: true })
  }, [isLoggedIn, navigate, state, homePath])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const data = Object.fromEntries(new FormData(event.currentTarget))
    loginUser(data as Credentials)
  }

  return (

    <RegisterArea>
    <AuthSkyline />
    <Area css={{ height: `calc((100vh / ${scale}) - ${NAVIGATION_HEIGHT})`, marginTop: `calc(${NAVIGATION_HEIGHT})`, display: 'flex', position: 'relative', zIndex: 1 }}>

    {/* <Container center expand dotted css={{
        // This creates your desired "buffer" at the top and bottom
        // padding: '10rem 1rem',
        paddingTop: `calc(10rem - ${displacement}rem)`,
        paddingBottom: '10rem',
        boxSizing: 'border-box',

        display: 'flex',
        alignItems: 'center',    // Vertically centers the form
        justifyContent: 'center',// Horizontally centers the form
      }}> */}


      <Helmet>
        <title>{titles.login}</title>
      </Helmet>

      <FormArea>

      <Form onSubmit={handleSubmit} 
        css={{
          maxHeight: `calc(100vh / ${scale})`
        }}
      >
        {/* <Header2>
        <Name>Tutee</Name>
        </Header2> */}


        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: 'max-content',
            alignItems: 'center',
            // marginBottom: '0.5rem',
        }}>
            <span style={{
                fontWeight: 'bold',
                fontSize: '1.8rem',
                lineHeight: '1',
                color: 'var(--colors-slate12, #1e293b)',
                letterSpacing: '-0.5px',
            }}>
                tute
            </span>
            <div style={{ width: '100%', height: '16px', marginTop: '0.1rem' }}>
                <BookLogo />
            </div>
        </div>
        <Tagline style={{ marginBottom: '0.5rem' }}>
          Sign in to your account
      </Tagline>



        <Field
          name="email"
          css={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.5rem',
          }}
        >
          <Label>Email</Label>
          <Control required />
          <Message match="valueMissing">Please enter your email</Message>
        </Field>

        <Field
          name="password"
          css={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.5rem',
          }}
        >
          <Label>Password</Label>
          <Control type="password" required autoComplete="on" />
          <Message match="valueMissing">Please enter your password</Message>
        </Field>
          <div>
            {null}
          </div>


        <FormActions>
        <Submit asChild>
          <Button tone="success" block>Login</Button>
        </Submit>
      <div>
      <Link to="/register" style={{ marginTop: '1rem', display: 'inline-block' }}>
        Need an account? Sign up here
      </Link>
      </div>
      <Link to="/forgot-password" style={{ marginTop: '1rem', display: 'inline-block' }}>
        Forgot password?
      </Link>
      </FormActions>
      </Form>
      </FormArea>
    {/* </Container> */}
    </Area>
    </RegisterArea>
  )
}

export default Login
